// 1 kilometer = 0.621371 miles. Also the km/h -> mph factor for speeds.
export const KILOMETERS_TO_MILES = 0.621371;
export const METERS_TO_MILES = KILOMETERS_TO_MILES / 1000;
export const METERS_PER_MILE = 1609.344;
